/**
 * A journal must change either the matter or the bank account, but not both and not neither.
 * Returns an error message when the combination is invalid, otherwise null.
 */
export function validateJournalTransfer(
    matterFromNo: number,
    matterToNo: number,
    bankAccountId1?: string | null,
    bankAccountId2?: string | null
): string | null {
    const sameMatter = matterFromNo === matterToNo;
    const sameAccount = bankAccountId1 === bankAccountId2;

    if (sameMatter && sameAccount) {
        return "Can't transfer to the same Matter and account";
    }

    if (!sameMatter && !sameAccount) {
        return 'You cannot move funds between matters and across bank accounts in the same transaction.';
    }

    return null;
}
